/**
 * Centralized utility functions for test status calculations
 * Ensures consistency across all pages (JEE/NEET Premium, PurchasedTests, etc.)
 */

/**
 * Calculate test status and expiry date based on purchase date and validity
 * @param {Date} purchasedDate - The date when the test was purchased
 * @param {number} validityYears - Number of years the test is valid for
 * @returns {{status: string, expiryDate: Date, isExpired: boolean}} Status object
 */
export const calculateTestStatus = (purchasedDate, validityYears) => {
  const expiryDate = new Date(purchasedDate);
  expiryDate.setFullYear(purchasedDate.getFullYear() + validityYears);
  const status = new Date() < expiryDate ? 'Active' : 'Expired';
  const isExpired = status === 'Expired';
  
  return { status, expiryDate, isExpired };
};

/**
 * Get transaction document ID for a user and test
 * @param {string} userId - User's UID
 * @param {string} testId - Test series ID
 * @returns {string} Transaction document ID
 */
export const getTransactionDocId = (userId, testId) => {
  return `${userId}_${testId}`;
};

/**
 * Parse purchase date from Firestore transaction data
 * @param {Object} txData - Transaction data from Firestore
 * @returns {Date} Parsed purchase date
 */
export const parsePurchaseDate = (txData) => {
  if (!txData || !txData.date) return new Date();
  return txData.date?.toDate ? txData.date.toDate() : new Date(txData.date);
};
